import { render, staticRenderFns } from "./ImportOrdersModal.vue?vue&type=template&id=a5a259e8"
import script from "./ImportOrdersModal.vue?vue&type=script&lang=ts"
export * from "./ImportOrdersModal.vue?vue&type=script&lang=ts"
import style0 from "./ImportOrdersModal.vue?vue&type=style&index=0&id=a5a259e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports